import React from 'react';

import VATPrice from './vat_price';

/**
 * rendering the VATPricing component with pricing service data
 * @param {Object} props
 * @param {string} props.id - product STEP id
 * @param {Object} props.prices - pricing service response
 * @param {boolean} props.isLoading - waiting for pricing response
 * @param {boolean} props.vatStatus - if true - showcase exclusive prices
 * @param {boolean} props.v1 - if true - build priceData without product id from array
 * @returns - <ProductPricing/>
 */
const ProductPricing = ({ id, prices, isLoading, vatStatus, v1 }) => {
  if (isLoading) return <span className="cef-loader cef-loader--medium" />;

  if (prices) {
    const priceData = {
      price: v1 ? +prices.price_inclusive : +prices[id].price_inclusive,
      excVATPrice: v1 ? +prices.price : +prices[id].price,
      quantity: v1
        ? +prices.per_pack
        : +prices[id].quantity || +prices[id].per_pack,
      unit: v1 ? prices.unit : prices[id].unit,
    };

    const { price, excVATPrice, quantity, unit } = priceData;

    return (
      <VATPrice
        price={price}
        excVATPrice={excVATPrice}
        quantity={quantity}
        unit={unit}
        incVat={vatStatus}
      />
    );
  }

  return false;
};

export default ProductPricing;
